// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__nROif","card_anim":"Card_card_anim__rlZ7K","logo-anim":"Card_logo-anim__GJ6H4","card__img":"Card_card__img__pcvES"};